/* Klaar listicle: top bar, reading bar, countdown, ?v= tests, pop-ups, the order form, cost buttons, phone bar. */
(function () {
  'use strict';
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var params = new URLSearchParams(location.search);
  var tests = (params.get('v') || '').toLowerCase().split(',').filter(Boolean);

  function init() {
    var top = document.querySelector('[data-lst-top]');

    /* ---- the pinned bar: keep the page clear of it ---- */
    var bar = document.querySelector('[data-lst-bar]');
    function barSize() { if (bar) document.documentElement.style.setProperty('--lst-bar-h', bar.offsetHeight + 'px'); }
    barSize();
    if (bar && 'ResizeObserver' in window) new ResizeObserver(barSize).observe(bar); else window.addEventListener('resize', barSize);

    /* ---- reading bar ---- */
    var prog = document.querySelector('[data-lst-progress]'), ticking = false;
    function progress() {
      ticking = false;
      if (!prog) return;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      prog.style.width = (max > 0 ? Math.min(100, Math.max(0, window.scrollY / max * 100)) : 0) + '%';
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(progress); } }, { passive: true });
    progress();

    /* ---- ?v= tests: swap the marked spots, and reorder reasons ---- */
    var rows = [];
    var data = document.getElementById('lst-tests');
    if (data) { try { rows = JSON.parse(data.textContent) || []; } catch (e) { rows = []; } }
    if (tests.length) {
      rows.forEach(function (r) {
        if (tests.indexOf(r[0]) < 0) return;
        if (r[1] === 'order') { reorder(String(r[2]).replace(/<[^>]*>/g, '')); return; }
        $$(document, '[data-lst-key="' + r[1] + '"]').forEach(function (n) { n.innerHTML = r[2]; });
      });
    }
    function reorder(spec) {
      var want = spec.split(',').map(function (x) { return parseInt(x, 10); }).filter(function (x) { return x > 0; });
      var list = document.querySelector('[data-lst-reason]');
      if (!list || !want.length) return;
      var parent = list.parentNode;
      var all = $$(parent, ':scope > [data-lst-reason]');
      var by = {};
      all.forEach(function (el) { by[el.getAttribute('data-lst-reason')] = el; });
      var slots = all.slice(0, want.length);
      var picked = want.map(function (k) { return by[k]; }).filter(Boolean);
      if (picked.length !== slots.length) return;
      var marks = slots.map(function (el) { var m = document.createComment('lst'); parent.insertBefore(m, el); return m; });
      marks.forEach(function (m, i) { parent.insertBefore(picked[i], m); });
      marks.forEach(function (m) { parent.removeChild(m); });
      $$(parent, ':scope > [data-lst-reason] [data-lst-num]').forEach(function (el, i) { el.textContent = (i + 1) + '.'; });
    }

    /* ---- countdown: runs to a real end date once, never restarts ---- */
    var endRaw = top ? (top.getAttribute('data-lst-end') || '').trim() : '';
    var end = endRaw ? new Date(endRaw).getTime() : NaN;
    var cds = $$(document, '[data-lst-cd]');
    function two(x) { return (x < 10 ? '0' : '') + x; }
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      cds.forEach(function (el) {
        if (left <= 0) {
          el.hidden = true;
          var sep = el.previousElementSibling;
          if (sep && sep.hasAttribute('data-lst-cd-sep')) sep.hidden = true;
          return;
        }
        var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
        var parts = [];
        if (d > 0) parts.push(d + 'D');
        parts.push(two(h), two(m));
        if (!el.hasAttribute('data-short')) parts.push(two(s));
        var label = el.getAttribute('data-label') || '';
        el.classList.add('is-live');
        el.innerHTML = (label ? '<span>' + label.replace(/</g, '&lt;') + '</span>' : '') +
          parts.map(function (p) { return '<span class="lst-cd__n">' + p + '</span>'; }).join('<span class="lst-cd__c">:</span>');
      });
      if (left > 0) setTimeout(tick, 1000 - (Date.now() % 1000));
    }
    if (!isNaN(end) && cds.length) tick();

    /* ---- cost per routine ---- */
    $$(document, '[data-lst-calc]').forEach(function (box) {
      var cents = parseInt(box.getAttribute('data-cents'), 10) || 9900, tpl = box.getAttribute('data-tpl') || '{c}¢';
      var out = box.querySelector('[data-lst-calc-out]'), btns = $$(box, '[data-kids]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var kids = parseInt(b.getAttribute('data-kids'), 10) || 1;
          btns.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
          out.textContent = tpl.replace('{c}', Math.round(cents / (730 * kids)));
        });
      });
    });

    /* ---- the pop-up and its order form ---- */
    var pop = document.querySelector('[data-lst-pop]');
    var trail = '';
    $$(document, '[data-lst-jump]').forEach(function (a) {
      a.addEventListener('click', function () { trail = a.getAttribute('data-lst-cta') || ''; });
    });
    if (pop && typeof pop.showModal === 'function') {
      var script = pop.querySelector('[data-lst-script]'), head = pop.querySelector('[data-lst-pophead]');
      var form = pop.querySelector('[data-lst-form]'), ctaIn = pop.querySelector('[data-lst-ctain]');
      var variant = pop.querySelector('[data-lst-variant]'), img = pop.querySelector('[data-lst-img]');
      var nameEl = pop.querySelector('[data-lst-name]'), input = pop.querySelector('[data-lst-input]');
      var chars = pop.querySelector('[data-lst-chars]'), hint = pop.querySelector('[data-lst-hint]'), hintText = hint ? hint.textContent : '';
      var colorName = pop.querySelector('[data-lst-colorname]'), ret = pop.querySelector('[data-lst-return]');
      var submit = pop.querySelector('[data-lst-submit]');
      var opener = null;

      function open(kind, cta, headHtml, from) {
        opener = from || null;
        var isScript = kind === 'script';
        pop.classList.toggle('is-script', isScript);
        if (script) script.hidden = !isScript;
        if (head) head.innerHTML = headHtml || head.getAttribute('data-default') || '';
        var tag = cta || 'listicle';
        if (trail && trail !== tag) tag += ' < ' + trail;
        if (tests.length) tag += ' · v=' + tests.join(',');
        if (ctaIn) ctaIn.value = tag;
        document.documentElement.classList.add('lst-lock');
        pop.showModal();
        pop.scrollTop = 0;
        fit();
      }
      function close() { if (pop.open) pop.close(); }
      pop.addEventListener('close', function () {
        document.documentElement.classList.remove('lst-lock');
        if (opener && opener.focus) opener.focus({ preventScroll: true });
      });
      pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
      $$(pop, '[data-lst-close]').forEach(function (b) { b.addEventListener('click', close); });
      $$(document, '[data-lst-open]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          open(a.getAttribute('data-lst-open'), a.getAttribute('data-lst-cta'), a.getAttribute('data-lst-head'), a);
        });
      });

      /* color */
      function setColor(radio) {
        var c = radio.getAttribute('data-lst-color');
        form.setAttribute('data-color', c);
        if (variant && radio.getAttribute('data-variant')) variant.value = radio.getAttribute('data-variant');
        if (colorName) colorName.textContent = radio.value;
        if (img) {
          var src = img.getAttribute('data-src-' + c);
          if (src) { img.srcset = src + '?width=600 600w, ' + src + '?width=900 900w'; img.src = src + '?width=900'; }
        }
      }
      $$(form, '[data-lst-color]').forEach(function (r) { r.addEventListener('change', function () { setColor(r); }); });

      /* name: same rules as the product page */
      var bad = /[^A-Za-zÀ-ɏ '’&.\-]/;
      function clean() { return input.value.replace(/\s+/g, ' ').trim(); }
      function say(text, alert) { if (!hint) return; hint.textContent = text; hint.classList.toggle('is-alert', !!alert); }
      function fit() {
        if (!nameEl) return;
        nameEl.style.fontSize = '';
        var r = document.createRange(); r.selectNodeContents(nameEl);
        var w = r.getBoundingClientRect().width, room = nameEl.clientWidth * 0.9;
        if (w > room && room > 0) nameEl.style.fontSize = (parseFloat(getComputedStyle(nameEl).fontSize) * room / w) + 'px';
      }
      if (input) {
        input.addEventListener('input', function (e) {
          if (!(e && e.isComposing) && bad.test(input.value)) {
            var at = input.selectionStart, before = input.value.length;
            input.value = input.value.split('').filter(function (ch) { return !bad.test(ch); }).join('');
            if (at != null) { at -= before - input.value.length; input.setSelectionRange(at, at); }
            say(hint.getAttribute('data-bad'), true);
          } else if (hint && hint.classList.contains('is-alert')) { say(hintText); }
          var v = clean();
          if (nameEl) { nameEl.textContent = v || input.placeholder; nameEl.classList.toggle('is-example', !v); fit(); }
          if (chars) chars.textContent = input.value.length + ' of 12';
        });
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);

      /* send: no empty name line in the cart, and no double taps */
      var busy = false;
      form.addEventListener('submit', function (e) {
        if (busy) { e.preventDefault(); return; }
        if (input) { var v = clean(); input.value = v; if (!v) input.disabled = true; }
        busy = true;
        if (submit) submit.setAttribute('aria-disabled', 'true');
        setTimeout(function () { busy = false; if (input) input.disabled = false; if (submit) submit.setAttribute('aria-disabled', 'false'); }, 8000);
      });
      function checkCart() {
        if (!ret || !window.fetch) return;
        var cartUrl = ret.getAttribute('data-cart') || '/cart';
        fetch(cartUrl + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
          .then(function (c) { ret.value = c.item_count > 0 ? cartUrl : '/checkout'; }).catch(function () {});
      }
      window.addEventListener('pageshow', function () { busy = false; if (input) input.disabled = false; checkCart(); });
    }

    /* ---- phone bar ---- */
    var sticky = document.querySelector('[data-lst-sticky]');
    if (sticky) {
      var delay = (parseInt(sticky.getAttribute('data-delay'), 10) || 0) * 1000;
      var go = sticky.querySelector('a');
      setTimeout(function () {
        sticky.classList.add('is-on');
        sticky.setAttribute('aria-hidden', 'false');
        if (go) go.tabIndex = 0;
        document.body.classList.add('lst-has-bar');
      }, delay);
    }

    /* ---- the finisher's link: glide to the offer box ---- */
    $$(document, '[data-lst-jump]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = (a.getAttribute('href') || '').replace('#', ''), t = id && document.getElementById(id);
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
